import { Injectable } from '@angular/core';
import { Response, Http } from "@angular/http";

import { Product } from "../models/product.model";

import { AuthService } from "../../auth/auth.service";

import 'rxjs/Rx';
import { Observable } from "rxjs/Observable";
import { AuthHttp } from "angular2-jwt/angular2-jwt";

import { AppSettings } from 'app.settings'
import { HttpClient } from '@angular/common/http';


@Injectable()
export class ProductService {
  private url: string = AppSettings.API_ENDPOINT + 'api/products/';

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getProducts(): Observable<Product[]> {
    //this.authService.reauthenticateIfTokenExpired();

    return this.http.get(this.url).map(
      (response: Response) => {
        const products: Product[] = (<any>response);
        return products;
      }
    );
  }

  getProduct(id: number): Observable<Product> {
    //this.authService.reauthenticateIfTokenExpired();

    return this.http.get(this.url + id).map(
      (response: Response) => {
        const product: Product = (<any>response);
        return product;
      }
    );
  }

}
